function removeEmptyOrNullObjectValue(obj) {
    Object.keys(obj).forEach((k) => (obj[k] && typeof obj[k] === "object" && removeEmptyOrNullObjectValue(obj[k])) ||
        (!obj[k] && obj[k] !== undefined && delete obj[k]));
    return obj;
}

export { removeEmptyOrNullObjectValue };
//# sourceMappingURL=remove-empty-or-null-object-value.js.map
